import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router } from '@angular/router';
import { ADPResourceService } from 'digital-core';

type Style = Partial<CSSStyleDeclaration>;

@Component({
  selector: "pgh-avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ['./avatar.component.scss']
})

export class AvatarComponent implements OnInit {
  @Input()
  public round = true;
  @Input()
  public size: string | number = 50;
  @Input()
  public textSizeRatio = 3;
  @Input()
  public bgColor: string | undefined;
  @Input()
  public fgColor = '#FFF';
  @Input()
  public borderColor: string | undefined;
  @Input()
  public style: Style = {};
  @Input()
  public cornerRadius: string | number = 0;
  @Input()
  public color?: string | null;
  @Input()
  public name?: string | null;
  @Input('name')
  public initials?: string | null;
  @Input()
  public initialsSize: string | number = 0;
  @Output()
  public clickOnAvatar: EventEmitter<any> = new EventEmitter<any>();
  public avatarStyle: Style = {};
  public hostStyle: Style = {};
  public avatarText: string | null = null;

  private colors: string[] = [];
  private assignedColors: { [initial: string]: string } = {};

  private users: { name: string, initials: string, color: string }[]=[];

  constructor(public resourcesService: ADPResourceService, private router: Router) {
  }

  ngOnInit() {

    this.colors = this.resourcesService.getPortalSetting('Global_Avatar_Colors').Value.split(',');
    this.initializeAvatar();
    this.buildTextAvatar();
  }

  private buildTextAvatar(): void {
    this.avatarText = this.getAvatar(+this.initialsSize);

    this.users.push({name:this.initials, initials:this.avatarText, color:this.color});
    this.assignColors(this.users);

    this.avatarStyle = this.getInitialsStyle(this.avatarText);

  }

  private initializeAvatar(): void {

      this.hostStyle = {
        width: this.size + 'px',
        height: this.size + 'px'
      };
  }

  /**
   *
   * returns initials style
   *
   * memberOf AvatarComponent
   */
  private getInitialsStyle(initials: string): Style {
    return {
      textAlign: 'center',
      borderRadius: this.round ? '100%' : this.cornerRadius + 'px',
      border: this.borderColor ? '1px solid ' + this.borderColor : '',
      textTransform: 'uppercase',
      color: this.fgColor,
      width: this.size + 'px',
      height: this.size + 'px',
      backgroundColor: this.bgColor
        ? this.bgColor
        : this.getColorForInitial(initials),
      font:
      Math.floor(+this.size / this.textSizeRatio) +
        'px Open Sans, sans-serif',
      lineHeight: this.size + 'px',
      ...this.style
    };
  }

  public assignColors(users: { name: string, initials: string, color: string }[]) {
    users.forEach(user => {
      const initial = user.initials.toUpperCase();

      if(user.color === null || user.color === undefined || user.color === '')
      {
        if (!this.assignedColors[initial]) {
          const colorIndex = (initial.charCodeAt(0) + initial.charCodeAt(1)) % this.colors.length;
          this.assignedColors[initial] = this.colors[colorIndex];
        } else {
          let colorIndex = this.colors.indexOf(this.assignedColors[initial]) + 1;
          if (colorIndex >= this.colors.length) {
            colorIndex = 0;
          }
          while (Object.values(this.assignedColors).includes(this.colors[colorIndex])) {
            colorIndex = (colorIndex + 1) % this.colors.length;
          }
          this.assignedColors[initial] = this.colors[colorIndex];
        }
      }else{
        this.assignedColors[initial] = user.color;
      }
    });
  }

  getColorForInitial(initial: string): string {
    const capitalizedInitial = initial.toUpperCase();
    return this.assignedColors[capitalizedInitial] || '';
  }

  public getAvatar(size: number): string {
    return this.getInitials(this.initials, size);
  }

  /**
   * Returns the initial letters of a name in a string.
   */
  private getInitials(name: string, size: number): string {
    name = name.trim();

    if (!name) {
      return '';
    }

    const initials = name.split(' ');

    if (size && size < initials.length) {
      return this.constructInitials(initials.slice(0, size));
    } else {
      return this.constructInitials(initials);
    }
  }

  /**
   * Iterates a person's name string to get the initials of each word in uppercase.
   */
  private constructInitials(elements: string[]): string {

    if (!elements || !elements.length) {
      return '';
    }

    return elements
      .filter(element => element && element.length > 0)
      .map(element => element[0].toUpperCase())
      .join('');
  }
}

